import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Button, Card, Empty, Form, message, Row, Col, Spin, Switch, Table, Typography } from 'antd'
import {
  SActionBtn,
  SBack,
  SFormImagesList,
  SGeneralForms,
  SLocalTreeSelected,
  SLowcodeList,
  SMessage,
  STableActions,
  STitle,
} from 'shj-components'
import { useParams } from 'react-router-dom'
import config from './configBank'
import configContract from './configContract'
import { authDict, useFileUrlPrefix } from 'shj-utils'
import AnnexEdit from './annex'
import ContractAdd from './contract'
import Edit from '../edit'
import {
  deleteContractById,
  deleteExtAccountById,
  deleteEmpOrg,
  findExtAccountByExtEmpId,
  findExtAccountById,
  findExtContractByExtEmpId,
  findOrgTree,
  getProjectExternalEmployeeDetail,
  projectExternalEmployeeupdateById,
  saveOrUpdateEmpOrg,
  searchEmpList,
  manualSendEdoc,
} from '@/services/externalPerson'
import dayjs from 'dayjs'
import styles from './index.module.less'
import { sendDimissionModal } from '@/pages/serviceConfig/externalPerson/sendDimissionModal'
import AddAndEditBankCard from '../addAndEditBankCard'
import { EyeInvisibleOutlined, EyeOutlined, FormOutlined } from '@ant-design/icons'
import { treeFormat } from '@/utils/data'
import { getWorkTypeList } from '@/services'
import { useSetState } from 'ahooks'

const AccountDetail = (props: any) => {
  const [form] = Form.useForm()
  const formRefs = useRef<any>()
  const formRefsAttachment = useRef<any>() //附件||银行卡信息||合同信息||附件
  const listRefContract = useRef<any>()
  const listRefBankCard = useRef<any>()
  const [detailInfo, setDetailInfo] = useState<any>()
  const [visible, setVisible] = useState<any>(false)
  const [workTypeList, setWorkTypeList] = useState<any>([])
  const [bankCardVisible, setBankCardVisible] = useState<any>(false)
  const [visibleAnnex, setVisibleAnnex] = useState<any>(false)
  const [visibleContract, setVisibleContract] = useState<any>(false)
  const [spinLoading, setSpinLoading] = useState(false)
  const [bankCardInfo, setBankCardInfo] = useState<any>({})
  const [contractInfo, setContractInfo] = useState<any>({})
  const [orgList, setOrgList] = useState<any>([])
  const [extraData, setExtraData] = useState([])
  const [state, setState] = useSetState({
    retryContractLoading: false,
  })
  const params = useParams()
  const fileUrlPrefix = useFileUrlPrefix()
  const id = params?.id || ''

  useEffect(() => {
    getDetail()
    getContract()
    getBankCardList()
    getEmpList()
    findOrgTree({}).then((res: any) => {
      setOrgList(res)
    })
  }, [])
  const isEditing = record => {
    // 两种情况。一种是编辑，一种是新增，新增没有id
    if (record.id) {
      return false
    } else {
      return !record.id
    }
  }
  const getContract = useCallback(() => {
    findExtContractByExtEmpId(1, 100, { extEmpId: id }).then(async (res: any) => {
      listRefContract.current?.updateDataSource(res?.list)
    })
  }, [])
  const getBankCardList = useCallback(() => {
    findExtAccountByExtEmpId(1, 100, { extEmpId: id }).then(async (res: any) => {
      listRefBankCard.current?.updateDataSource(res?.list)
    })
  }, [])
  const getEmpList = useCallback(() => {
    searchEmpList({ extEmpId: id }).then(async (res: any) => {
      setExtraData(res)
    })
  }, [])
  const getDetail = useCallback(() => {
    setSpinLoading(true)
    getProjectExternalEmployeeDetail({ id })
      .then(async (res: any) => {
        if (res) {
          formRefs?.current?.onFormRef()?.resetFields()
          res.sexDesc = res.sex ? '男' : '女'
          let workTypeList: any = []
          if (res.empWorkTypeList && res.empWorkTypeList.length) {
            for (let m of res.empWorkTypeList) {
              workTypeList.push(m.workTypeName)
            }
          }
          res.workerList = workTypeList.join(',')
          let empCompanyList: any = []
          if (res.empCompanyList && res.empCompanyList.length) {
            for (let m of res.empCompanyList) {
              if (`${m.onJobFlag}` === '1') {
                empCompanyList.push(
                  m.companyName + `${m.departmentName ? '-' : ''}` + `${m?.departmentName || ''}`
                )
              }
            }
          }
          res.empCompanyName = empCompanyList.join(',')
          let receivingAreaList: any = []
          if (res.receivingAreaList && res.receivingAreaList.length) {
            for (let m of res.receivingAreaList) {
              receivingAreaList.push(m.cityRegionName + '-' + m.countyRegionName)
            }
          }
          res.receivingAreaName = receivingAreaList.join(',')
          res.joinDate = dayjs(res.joinDate).format('YYYY-MM-DD')
        }
        setDetailInfo(res)
        formRefs?.current?.onFormRef()?.setFieldsValue({ ...res })
        formRefsAttachment?.current?.onFormRef()?.setFieldsValue({ ...res })
        setSpinLoading(false)
      })
      .finally(() => {
        setSpinLoading(false)
      })
  }, [])

  const onDepart = () => {
    sendDimissionModal({
      title: '离职确认',
      callback: () => {
        getDetail()
      },
      detailInfo,
    })
  }
  const onUse = () => {
    projectExternalEmployeeupdateById({
      id: detailInfo?.id,
      actStatus: true,
    })
      .then(res => {
        message.success(res?.message || '操作成功')
        getDetail()
      })
      .catch(() => {})
  }
  const editBankCardModel = () => {
    setBankCardInfo([])
    setBankCardVisible(true)
  }

  const retryContract = () => {
    // console.log('retryContract  id', id)
    setState({
      retryContractLoading: true,
    })
    return manualSendEdoc({
      extEmpId: id,
    })
      .then((res: any) => {
        console.log('retryContract res：', res)
        let tips = ''
        if (res.successFlag) {
          tips = `${res.successVendorName || ''}${res.failVendorName || ''}`
        } else {
          tips = res.message || '操作失败'
        }
        if (tips) {
          message.success(tips)
        }
      })
      .finally(() => {
        setState({
          retryContractLoading: false,
        })
      })
  }

  const contractModel = () => {
    setContractInfo({})
    setVisibleContract(true)
  }
  const closeBankCardDetails = () => {
    setBankCardVisible(false)
  }
  const closeDetails = () => {
    setVisible(false)
    setVisibleAnnex(false)
    setVisibleContract(false)
  }

  const deleteBank = id => {
    const dialog = SMessage.delete({
      onOk: async () => {
        try {
          const res: any = await deleteExtAccountById(id)
          if (res.errorCode === 0) {
            message.success('删除成功')
            getBankCardList()
          } else {
            message.error('删除失败')
          }
        } catch (err) {
          console.log(err)
        }
        dialog?.destroy()
      },
      onCancel: () => {
        message.warning('取消删除')
        dialog?.destroy()
      },
    })
  }
  const deleteContract = id => {
    const dialog = SMessage.delete({
      onOk: async () => {
        try {
          const res: any = await deleteContractById(id)
          if (res.errorCode === 0) {
            message.success('删除成功')
            getContract()
          } else {
            message.error('删除失败')
          }
        } catch (err) {
          console.log(err)
        }
        dialog?.destroy()
      },
      onCancel: () => {
        message.warning('取消删除')
        dialog?.destroy()
      },
    })
  }
  const toEditInfo = async () => {
    const workTypeList: any = await getWorkTypeList(true);
    setWorkTypeList(workTypeList)
    setVisible(true)
  }
  const toEditBank = record => {
    setBankCardVisible(true)
    if (record.id) {
      setBankCardInfo({ ...record })
    }
  }
  const toAnnexEdit = () => {
    setVisibleAnnex(true)
  }
  const cancel = (id: any, index: number) => {
    if (!id) {
      const newData = [...extraData]
      newData.splice(index, 1)
      setExtraData(newData)
    }
    form.resetFields()
  }
  const save = async (recordId, enabled?) => {
    try {
      const row = await form.validateFields()
      const newData: any = [...extraData]
      if (JSON.stringify(row) !== '{}' && recordId) {
        return message.warning('请先保存信息')
      }
      const index = newData.findIndex(item => recordId === item.id)
      saveOrUpdateEmpOrg({
        enabled:
          enabled != undefined
            ? enabled
            : row.enabled != undefined
            ? row.enabled
            : newData[index].enabled,
        extEmpId: id,
        id: recordId,
        orgId: row.orgnamePath || newData[index].orgId,
      })
        .then(res => {
          getEmpList()
          form.resetFields()
          message.success('保存成功')
        })
        .catch(err => {
          message.error(err.message)
        })
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo)
    }
  }
  const setPhone = (name, labelFlag) => {
    getProjectExternalEmployeeDetail({ id, labelFlag }).then(async (res: any) => {
      formRefs?.current?.onFormRef()?.setFieldValue(name, res[name])
      detailInfo[name] = res[name]
      setDetailInfo({ ...detailInfo })
    })
  }
  const setBankCard = (record, name, labelFlag) => {
    findExtAccountById({ id: record.id, labelFlag }).then(async (res: any) => {
      const updatedBankCardList = listRefBankCard.current?.getDataSource().map(item => {
        if (item.id === record.id) {
          return { ...item, [name]: res[name] }
        }
        return item
      })

      listRefBankCard.current?.updateDataSource(updatedBankCardList)
    })
  }
  const handleDelete = async (record: any) => {
    const row = await form.validateFields()
    if (JSON.stringify(row) !== '{}' && record.id) {
      return message.warning('请先保存信息')
    }
    const dialog = SMessage.delete({
      onOk: async () => {
        try {
          const res: any = await deleteEmpOrg(record.id)
          if (res.errorCode === 0) {
            message.success('删除成功')
            getEmpList()
          } else {
            message.error('删除失败')
          }
        } catch (err) {
          console.log(err)
        }
        dialog?.destroy()
      },
      onCancel: () => {
        message.warning('取消删除')
        dialog?.destroy()
      },
    })
  }
  const onChangeStatus = async (checked, record) => {
    const row = await form.validateFields()
    if (JSON.stringify(row) !== '{}' && record.id) {
      return message.warning('请先保存信息')
    }
    SMessage.confirm({
      title: checked ? '启用操作' : '禁用操作',
      content: `确定继续操作吗？`,
      onOk: async () => {
        try {
          await save(record.id, checked)
        } catch (e) {
          console.log(e)
        }
      },
    })
  }
  const columns = [
    {
      title: '部门',
      dataIndex: 'orgnamePath',
      isSelect: true,
      width: 100,
      editable: true,
    },
    {
      title: '状态',
      dataIndex: 'enabled',
      width: 80,
      editable: true,
      render: (v: boolean, record: Record<string, any>) => (
        <Switch
          disabled={!authDict['externalPersonDeptState']}
          checkedChildren="启用"
          unCheckedChildren="禁用"
          value={record.enabled}
          onClick={checked => onChangeStatus(checked, record)}
        />
      ),
    },
    {
      title: '操作',
      dataIndex: 'operation',
      fixed: 'right',
      width: 120,
      render: (_, record, index) => {
        const editable = isEditing(record)
        return editable ? (
          <span>
            <Typography.Link
              onClick={() => save(record.id)}
              style={{
                marginRight: 8,
              }}
            >
              保存
            </Typography.Link>
            <a onClick={() => cancel(record.id, index)}>取消</a>
          </span>
        ) : (
            authDict['externalPersonDelDept'] ? 
            <SActionBtn danger onClick={() => handleDelete(record)}>
              删除
            </SActionBtn>
            : null
        )
      },
    },
  ]
  const mergedColumns = columns.map(col => {
    if (!col.editable) {
      return col
    }
    return {
      ...col,
      onCell: (record, index) => ({
        record,
        index,
        dataIndex: col.dataIndex,
        title: col.title,
        isSelect: col.isSelect,
        editing: isEditing(record),
      }),
    }
  })
  const EditableCell = ({ editing, dataIndex, record, isSelect, children, ...restProps }) => {
    // 添加一个函数来检查节点是否为叶子节点
    const treeData = useMemo(
      () =>
        treeFormat(orgList || [], {
          format: item => ({
            ...item,
            disabled: (item.children || []).length || item.object.orgType === 'COMPANY',
          }),
        }),
      [orgList]
    )
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: dataIndex === 'orgnamePath' ? true : false,
                message: `业务组织不能为空`,
              },
            ]}
          >
            {isSelect ? (
              <SLocalTreeSelected
                treeDefaultExpandAll
                placeholder={'请选择业务组织'}
                fieldNames={{ label: 'label', value: 'id' }}
                treeCheckable={false}
                treeData={treeData}
              />
            ) : (
              <Switch
                checkedChildren="启用"
                unCheckedChildren="禁用"
                defaultChecked={record[dataIndex]}
              />
            )}
          </Form.Item>
        ) : (
          <>{children}</>
        )}
      </td>
    )
  }
  // 新增部门
  const handleAddNewExtraInfo = () => {
    const index = extraData.findIndex((item: any) => !item.id)
    if (index > -1) return
    const newData: any = [...extraData]

    newData.unshift({
      id: '',
      enabled: true,
    })
    setExtraData(() => {
      return newData
    })
  }

  const extensionContract = {
    events: { contractModel },
    customRender: {
      setContratTime(_: any, record: any) {
        return (
          dayjs(record.startTime).format('YYYY-MM-DD') +
          ' - ' +
          dayjs(record.endTime).format('YYYY-MM-DD')
        )
      },
      actionTool(text: any, record: any) {
        return record.typeName === '电子合同' ? (
          <STableActions>
            <SActionBtn
              auth="lookElecContract"
              href={
                record?.fileInfolist && record?.fileInfolist.length > 0
                  ? fileUrlPrefix + record?.fileInfolist[0]
                  : ''
              }
              target="_blank"
            >
              查看
            </SActionBtn>
          </STableActions>
        ) : (
          <STableActions>
            <SActionBtn
              auth="lookOfflineContract"
              onClick={() => {
                setVisibleContract(true)
                const contractInfo = { ...record }
                contractInfo.signDate = dayjs(contractInfo.signDate)
                contractInfo.startTime = dayjs(contractInfo.startTime)
                contractInfo.contratTime = [
                  dayjs(contractInfo.startTime),
                  dayjs(contractInfo.endTime),
                ]
                contractInfo.fileInfolist = contractInfo.fileInfolist.map(item => {
                  return {
                    uid: item,
                    url: fileUrlPrefix + item,
                    relativePath: item,
                  }
                })
                setContractInfo(contractInfo)
              }}
            >
              查看
            </SActionBtn>
            <SActionBtn
              auth="externalPersonContractDelete"
              danger
              onClick={() => deleteContract(record.id)}
            >
              删除
            </SActionBtn>
          </STableActions>
        )
      },
    },
  }

  const extension = {
    events: {},
    customRender: {
      imgBackUrlApproval(_: any, record: any) {
        let fileList = [
          {
            uid: record.imgBackUrl,
            url: fileUrlPrefix + record.imgBackUrl,
          },
        ]
        return record.imgBackUrl ? <SFormImagesList imagesList={fileList} /> : null
      },
      idCardApproval(_: any, record: any) {
        return (
          <div>
            <span>{record.idCard}</span>
            {authDict['lookPersonDetail'] ? (
              record && record['idCard'] && record['idCard'].includes('*') ? (
                <EyeInvisibleOutlined
                  style={{ cursor: 'pointer' }}
                  onClick={() => setBankCard(record, 'idCard', true)}
                />
              ) : (
                <EyeOutlined
                  onClick={() => setBankCard(record, 'idCard', false)}
                  style={{ cursor: 'pointer' }}
                />
              )
            ) : null}
          </div>
        )
      },
      accountCodeApproval(_: any, record: any) {
        return (
          <div>
            <span>{record.accountCode}</span>
            {authDict['lookPersonDetail'] ? (
              record && record['accountCode'] && record['accountCode'].includes('*') ? (
                <EyeInvisibleOutlined
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setBankCard(record, 'accountCode', true)
                  }}
                />
              ) : (
                <EyeOutlined
                  onClick={() => setBankCard(record, 'accountCode', false)}
                  style={{ cursor: 'pointer' }}
                />
              )
            ) : null}
          </div>
        )
      },
      imgFrontUrlApproval(_: any, record: any) {
        let fileList = [
          {
            uid: record.imgFrontUrl,
            url: fileUrlPrefix + record.imgFrontUrl,
          },
        ]
        return record.imgFrontUrl ? <SFormImagesList imagesList={fileList} /> : null
      },
      bankTypeApproval(text: any) {
        return text ? '主卡' : '副卡'
      },
      actionTool(text: any, record: any) {
        return (
          <STableActions>
            <SActionBtn
              auth="externalPersonBankEdit"
              onClick={() => {
                toEditBank(record)
              }}
            >
              编辑
            </SActionBtn>
            {!record?.mainFlag ? (
              <SActionBtn
                auth="externalPersonBankDelete"
                danger
                onClick={() => deleteBank(record.id)}
              >
                删除
              </SActionBtn>
            ) : null}
          </STableActions>
        )
      },
    },
  }
  const title_ = `工人详情`
  return (
    <SBack
      // titleStyle={{ marginBottom: 10 }}
      level={2}
      title={detailInfo?.userName ? `${title_}` : '工人详情'}
    >
      <div className={styles.externalPersonDetail}>
        <Card bordered={false} style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
          <Spin spinning={spinLoading}>
            <SGeneralForms
              ref={formRefs}
              title="工人详情"
              isDetail={true}
              configs={[
                {
                  title: '基本信息',
                  customBtn: [
                    authDict['externalPersonEdit'] ? (
                      <Button type="primary" onClick={toEditInfo}>
                        编辑
                      </Button>
                    ) : null,
                    detailInfo?.actStatus ? (
                      authDict['externalPersonDimission'] ?
                      <Button onClick={onDepart}>离职</Button> : null
                    ) : 
                    (
                      authDict['externalPersonActive'] ?
                      <STableActions.SActionBtn
                        type="primary"
                        title="是否启用？"
                        confirm
                        onClick={onUse}
                        okText="确认"
                        cancelText="取消"
                      >
                        启用
                      </STableActions.SActionBtn> : null
                    ),
                  ],
                  formItem: [
                    {
                      name: 'extCode',
                      label: '账号ID',
                      spanCol: 6,
                    },
                    {
                      name: 'name',
                      label: '姓名',
                      spanCol: 6,
                    },
                    {
                      name: 'sexDesc',
                      label: '性别',
                      spanCol: 6,
                    },
                    {
                      name: 'phone',
                      label: '电话',
                      spanCol: 6,
                      children: () => (
                        <div style={{ color: 'rgb(102, 102, 102)' }}>
                          <span>{detailInfo?.phone}</span>
                          {authDict['lookPersonDetail'] ? (
                            detailInfo && detailInfo?.phone && detailInfo?.phone.includes('*') ? (
                              <EyeInvisibleOutlined
                                onClick={() => setPhone('phone', true)}
                                style={{ cursor: 'pointer' }}
                              />
                            ) : (
                              <EyeOutlined
                                onClick={() => setPhone('phone', false)}
                                style={{ cursor: 'pointer' }}
                              />
                            )
                          ) : null}
                        </div>
                      ),
                    },
                    {
                      name: 'idCard',
                      label: '身份证号码',
                      spanCol: 6,
                      children: () => (
                        <div style={{ color: 'rgb(102, 102, 102)' }}>
                          <span>{detailInfo?.idCard}</span>
                          {authDict['lookPersonDetailIdCard'] ? (
                            detailInfo && detailInfo?.idCard && detailInfo?.idCard.includes('*') ? (
                              <EyeInvisibleOutlined
                                onClick={() => setPhone('idCard', true)}
                                style={{ cursor: 'pointer' }}
                              />
                            ) : (
                              <EyeOutlined
                                onClick={() => setPhone('idCard', false)}
                                style={{ cursor: 'pointer' }}
                              />
                            )
                          ) : null}
                        </div>
                      ),
                    },
                    {
                      name: 'joinDate',
                      label: '添加日期',
                      spanCol: 6,
                    },
                    {
                      name: 'industryAge',
                      label: '行业工龄',
                      spanCol: 6,
                    },
                    {
                      name: 'emergencyPhone',
                      label: '紧急联系电话',
                      spanCol: 6,
                    },
                    {
                      name: 'typeName',
                      label: '人员类型',
                      spanCol: 6,
                    },
                    {
                      name: 'workTypeNames',
                      label: '技能标签',
                      spanCol: 6,
                    },
                    {
                      name: 'ownerUserName',
                      label: '推荐人',
                      spanCol: 6,
                    },

                    {
                      name: 'vendorInfoNames',
                      label: '承包商',
                      spanCol: 6,
                    },
                    {
                      name: 'actStatusName',
                      label: '状态',
                      spanCol: 6,
                    },
                    {
                      name: 'leaveDate',
                      label: '离职日期',
                      spanCol: 6,
                      type: 'date',
                      hidden: detailInfo?.actStatus,
                    },
                    {
                      name: 'addressAddress',
                      label: '居住地',
                      spanCol: 12,
                    },
                    {
                      name: 'workExperience',
                      label: '从业描述',
                      spanCol: 12,
                    },
                    {
                      name: 'censusRegisterAreaName',
                      label: '户籍所在地',
                      spanCol: 12,
                    },
                  ],
                },
                {
                  formItem: [
                    {
                      name: '',
                      label: '',
                      spanCol: 24,
                      children: (
                        <>
                          <Row style={{ marginBottom: '10px' }} justify="end">
                            {authDict['externalPersonAddDept'] ? 
                            <Button type="primary" onClick={handleAddNewExtraInfo}>
                              新增
                            </Button>: null}
                          </Row>
                          <Form form={form} component={false}>
                            <Table
                              size={'middle'}
                              pagination={false}
                              components={{
                                body: {
                                  cell: EditableCell,
                                },
                              }}
                              scroll={{
                                x: 1500,
                              }}
                              bordered
                              dataSource={extraData}
                              columns={mergedColumns}
                            />
                          </Form>
                        </>
                      ),
                    },
                  ],
                },
                {
                  title: '业务信息',
                  formItem: [
                    {
                      name: 'orderAbility',
                      label: '接单能力',
                      spanCol: 6,
                    },
                    {
                      name: 'estate',
                      label: '等级',
                      spanCol: 6,
                    },
                    {
                      name: 'serviceScore',
                      label: '服务分',
                      spanCol: 6,
                    },
                    {
                      name: 'acceptStatusName',
                      label: '接单状态',
                      spanCol: 6,
                    },
                    {
                      name: 'receivingAreaName',
                      label: '服务区域',
                      spanCol: 12,
                    },
                  ],
                },
              ]}
            />
            <STitle
              title={
                <div style={{ fontWeight: 400 }} className={styles.flex_space_between}>
                  银行信息
                  {authDict['externalPersonBankCardAdd'] ? 
                  <Button type="primary" onClick={editBankCardModel}>
                    新增
                  </Button> : null}
                  
                </div>
              }
            />
            <SLowcodeList searchMode="group" config={config} ref={listRefBankCard} {...extension} />

            <STitle
              title={
                <div style={{ fontWeight: 400 }} className={styles.flex_space_between}>
                  合同信息
                  <Row gutter={12}>
                    <Col>
                    {authDict['externalPersonElecContractAdd'] ? 
                      <Button
                        type="primary"
                        ghost
                        onClick={retryContract}
                        loading={state.retryContractLoading}
                      >
                        发起电子合同
                      </Button> : null}
                    </Col>
                    <Col>
                    {authDict['externalPersonContractAdd'] ? 
                      <Button type="primary" onClick={contractModel}>
                        新增
                      </Button> : null}
                    </Col>
                  </Row>
                </div>
              }
            />
            <SLowcodeList
              searchMode="group"
              config={configContract}
              ref={listRefContract}
              {...extensionContract}
            />

            <STitle
              title={
                <div style={{ fontWeight: 400 }} className={styles.flex_space_between}>
                  附件
                  {authDict['externalPersonAnnexAdd'] ? 
                  <Button type="primary" onClick={toAnnexEdit}>
                    新增
                  </Button> : null}
                </div>
              }
            />
            {detailInfo?.employeePhotoUrl ? (
              <SGeneralForms
                layout="vertical"
                configs={[
                  {
                    titleMode: 'drawer',
                    formItem: [
                      {
                        name: 'employeePhotoUrl',
                        label: '个人照片',
                        spanCol: 8,
                        required: true,
                        htmlFor: 'imgUrl',
                        children: (
                          <SFormImagesList
                            imagesList={[
                              {
                                uid: detailInfo?.employeePhotoUrl,
                                url: fileUrlPrefix + detailInfo?.employeePhotoUrl,
                              },
                            ]}
                          />
                        ),
                      },
                      {
                        name: 'idCardFrontUrl',
                        label: '身份证人面像',
                        spanCol: 8,
                        required: true,
                        htmlFor: 'imgUrl',
                        children: (
                          <SFormImagesList
                            imagesList={[
                              {
                                uid: detailInfo?.idCardFrontUrl,
                                url: fileUrlPrefix + detailInfo?.idCardFrontUrl,
                              },
                            ]}
                          />
                        ),
                      },
                      {
                        name: 'idcardBackUrl',
                        label: '身份证国徽面',
                        spanCol: 8,
                        required: true,
                        htmlFor: 'imgUrl',
                        children: (
                          <SFormImagesList
                            imagesList={[
                              {
                                uid: detailInfo?.idcardBackUrl,
                                url: fileUrlPrefix + detailInfo?.idcardBackUrl,
                              },
                            ]}
                          />
                        ),
                      },
                    ],
                  },
                ]}
              />
            ) : (
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
          </Spin>
        </Card>
        {/* 附件查看 */}
        <AnnexEdit
          record={detailInfo}
          visibleDrawer={visibleAnnex}
          closeDetails={closeDetails}
          getDetail={getDetail}
        ></AnnexEdit>
        {/* 编辑基本信息 */}
        <Edit
          visibleDrawer={visible}
          closeDetails={closeDetails}
          record={detailInfo}
          getDetail={getDetail}
          workTypeList={workTypeList}
        ></Edit>
        {/* 新增/编辑银行卡信息 */}
        <AddAndEditBankCard
          visibleDrawer={bankCardVisible}
          closeDetails={closeBankCardDetails}
          record={bankCardInfo}
          id={id}
          getDetail={getBankCardList}
        />
        {/* 新增/查看合同信息 */}
        <ContractAdd
          record={detailInfo}
          visibleDrawer={visibleContract}
          closeDetails={closeDetails}
          getDetail={getContract}
          contractInfo={contractInfo}
        ></ContractAdd>
      </div>
    </SBack>
  )
}

export default AccountDetail
